// Loads the page-specific jobseekers-new.css (~126KB / ~17KB gz) ONCE, async (preload→stylesheet),
// when a component that needs it is created — so it ships ONLY on the /jobseeker landing + the
// Lucky-Draw pages, never site-wide.
//
// Before: those 3 components each had `@import "/assets/css/jobseekers-new.css"` in their <style>.
// Because 3 different async chunks imported the same absolute-URL sheet, webpack HOISTED that @import
// into the initial `app.css` bundle → it loaded render-blocking on EVERY page (R12 made app.css async,
// but it still DOWNLOADED everywhere). This mixin removes it from the global bundle and fetches it only
// where a consuming component actually mounts.
//
// - Idempotent: a single #id link, so multiple consumers on one page (e.g. two Lucky-Draw headers) add
//   it once, and a prerendered page's baked link isn't re-injected on hydration.
// - Prerender-safe: during prerender Puppeteer fires the onload (rel→stylesheet); vue.config.js
//   postProcess reverts it to rel="preload" so the static /jobseeker page keeps it async.
// - Route-agnostic: works identically for the public landing and the authed Lucky-Draw pages, so the
//   public/authed "mixed sheet" split never has to be reasoned about — everyone gets the full sheet.
export default {
  created() {
    if (typeof document === 'undefined') return;
    var id = 'css-jobseekers-new';
    if (document.getElementById(id)) return;
    var l = document.createElement('link');
    l.id = id;
    l.rel = 'preload';
    l.setAttribute('as', 'style');
    l.href = '/assets/css/jobseekers-new.css';
    l.setAttribute('onload', "this.onload=null;this.rel='stylesheet'");
    document.head.appendChild(l);
  }
};
